import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ArrowFullRight(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 18"
  }, props), React.createElement("path", {
    d: "M15.702.282a.964.964 0 011.363 0l7.71 7.71a.964.964 0 010 1.363l-7.71 7.71a.964.964 0 11-1.363-1.363l6.065-6.065H.964a.964.964 0 010-1.927h20.803l-6.065-6.065a.964.964 0 010-1.363z"
  }));
}

export { ArrowFullRight };
//# sourceMappingURL=ArrowFullRight.js.map